import { userFavorite } from '@/service'
const collect_list = {
  data() {
    return {
      loading: false,
      list: [],
      more: true,
      page: 1
    }
  },
  methods: {
    async userFavorite(type, cb) {
      this.loading = true
      let res = await userFavorite({
        user_key: this.$store.state.user_key,
        page: this.page,
        type: type
      }, (error) => {
        this.$Message.error('请求错误')
      })
      if (res.status == 'success') {
        this.$parent.loading = false
        this.loading = false
        this.list = [...this.list, ...res.res]
        if (res.res.length < 10) {
          this.more = false
        }
        console.log(this.more)
        if(cb) cb(res)
      } else {
        this.$Message.error(res.message)
      }
    },
    handleCancel(content_type, content_id, collectCb, cb_param) {
      this.$parent.message_model = true
      this.$parent.content_type = content_type
      this.$parent.content_id = content_id
      this.$parent.collectCb = collectCb
      this.$parent.cb_param = cb_param
    },
    cancelCollectCb(index) {
      this.list.splice(index, 1)
    },
    handleMore(t) {
      this.page ++
      this.userFavorite(t)
    }
  }
}

export { collect_list }
